export default function SanityIndicator({ sanity, tooltip }: { sanity: number, tooltip?: string }) {
    const title = tooltip ?? "Sanity";

    if (sanity < 50) {
        return <span className="badge p-1 ms-1 bg-info rounded-pill text-dark" title={title}><i className="bi-activity"></i> {sanity}%</span>
    } else if (sanity > 50) {
        return <span className="badge p-1 ms-1 bg-danger rounded-pill text-dark" title={title}><i className="bi-activity"></i> {sanity}%</span>
    } else {
        return <span className="badge p-1 ms-1 bg-warning rounded-pill text-dark" title={title}><i className="bi-activity"></i> {sanity}%</span>
    }
}